import { useIntl } from 'react-intl'
import Stack from '../components/layout/Stack'
import Background from '../components/layout/Background'
import AppChrome from '../components/AppChrome'
import Hero from '../components/Hero'
import ContentBuilder from '../components/ContentBuilder'
import LetsShare from '../components/LetsShare'
import LetsMake from '../components/LetsMake'
import LetsDiscusCTABlock from '../components/LetsDiscusCTABlock'
import Faqs from '../components/Faqs'
import MetaTags from '../components/MetaTags'

export { getServerSideProps } from '../graphql/lets-explore'

function LetsExplorePage( { 
  entry: letsExplore, 
  letsMake,
  letsShare,
  activities,
} ) {
  const { formatMessage } = useIntl()
  const heroContent = letsExplore.hero[ 0 ]

  return (
    <AppChrome>
      <MetaTags
        url="/lets-explore"
        title={ formatMessage( {
          description: 'Let’s Explore',
          defaultMessage: 'Let’s Explore',
          id: 'n4jYlJ',
        } ) }
      />
      <Background 
        $color="grey9"
      >
        <Hero 
          title={ heroContent.heroTitle }
          subheading={ heroContent.subtitle }
          html={ heroContent.body }
          bottomPad="small"
        />
        <Stack $bottom={ 4 }>
          <ContentBuilder 
            content={ letsExplore.contentBuilder }
          />
        </Stack>
        <Stack
          $top={ 3 }
          $bottom={ 3 }
        >
          <LetsShare
            title={ letsShare.title }
            description={ letsShare.description }
          />
        </Stack>
        <Stack
          $top={ 3 }
          $bottom={ 3 }
        >
          <LetsMake 
            title={ letsMake.title }
            description={ letsMake.description }
            activities={ activities } 
          />
        </Stack>
        <Stack
          $top={ 3 }
          $bottom={ 3 }
        >
          <Faqs faqs={ letsExplore.faqs[ 0 ] } />
        </Stack>
        <LetsDiscusCTABlock />
      </Background>
    </AppChrome>
  )
}

export default LetsExplorePage
